export default __webpack_public_path__ + "static/media/depositWithdrawalIcon2.a122d4c7.webp";